module.exports = __webpack_public_path__ + "img/bo.4ac8e72d.svg";